const activityStorage = {
  state:{

  },
  mutations:{

  },
  action:{

  },
  getters:{

  }

}
export default activityStorage